module.exports = __webpack_public_path__ + "img/ico_app.67777009.png";